import { useState } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import CEOIllustration from 'images/CEO Illustration.png'
import { Section, FlexColumn, ConditionalDiv } from 'components/common/common_styles'
import RichText from 'components/common/richText'
import Quote from 'components/common/quote'
import UnderlineImage from 'images/Underline Illustration v2.png'
import { MainContainer, MapContainer, LowerTextContainer, MobileTitleSelector, MobileTitle, MobileUnderline } from './homeMap_styles'

const HomeMap = () => {
  const { prismicHomePage: { data } } = useStaticQuery(query)
  const [textIndex, setTextIndex] = useState(0)

  const selectTitle = index => () => {
    setTextIndex(index)
  }

  return (
    <Section washi>
      <MainContainer padTop={[4, 3]} padBottom={6} padLeft padRight washi>
        <Quote image={CEOIllustration} quote={data.map_quote} attribution={data.map_attribution} />
        <MapContainer data={data.map_image} />
        <ConditionalDiv desktopOnly>
          <LowerTextContainer>
            {data.map_copy.map(mapCopy =>
              <FlexColumn key={mapCopy.title}>
                <h3>{mapCopy.title}</h3>
                <RichText data={mapCopy.body} />
                <Link to={`/${mapCopy.button_link}`}>
                  {mapCopy.button_text}
                </Link>
              </FlexColumn>
            )}
          </LowerTextContainer>
        </ConditionalDiv>
        <ConditionalDiv mobileOnly>
          <MobileTitleSelector>
            {data.map_copy.map((copy, index) =>
              <MobileTitle key={copy.short_title} variant='h4' onClick={selectTitle(index)} selected={index === textIndex}>
                {copy.short_title}
                {index === textIndex &&
                  <MobileUnderline src={UnderlineImage} alt='' />
                }
              </MobileTitle>
            )}
          </MobileTitleSelector>
          <FlexColumn key={data.map_copy[textIndex].title}>
            <h3>{data.map_copy[textIndex].title}</h3>
            <RichText data={data.map_copy[textIndex].body} />
            <Link to={`/${data.map_copy[textIndex].button_link}`}>
              {data.map_copy[textIndex].button_text}
            </Link>
          </FlexColumn>
        </ConditionalDiv>
      </MainContainer>
    </Section>
  )
}

export default HomeMap

export const query = graphql`
  query {
    prismicHomePage {
      data {
        map_attribution
        map_copy {
          button_link
          button_text
          title
          short_title
          body {
            richText
          }
        }
        map_quote {
          richText
        }
        map_image {
          alt
          gatsbyImageData
        }
      }
    }
  }
`
